export const UI_LAYOUT_SET = 'ui/layout/set';
export const UI_LAYOUT_GET = 'ui/layout/get';

export const LAYOUT_DEFAULT = 'layout-default';
export const LAYOUT_AUTH    = 'layout-auth';

const VALID_LAYOUTS = [
    LAYOUT_DEFAULT,
    LAYOUT_AUTH,
];

const state = {
    layout: LAYOUT_DEFAULT,
};

const getters = {
    [UI_LAYOUT_GET]: (state) => state.layout
};

const actions = {
    [UI_LAYOUT_SET]({commit}, layout) {
        const found = VALID_LAYOUTS.find((l) => l === layout);

        commit(UI_LAYOUT_SET, found);
    }
};

const mutations = {
    [UI_LAYOUT_SET](state, layout = LAYOUT_DEFAULT) {
        state.layout = layout;
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
}
